export default [
  [`Размер`, `XS`, `S`, `M`, `L`, `XL`],
  [`Российский размер`, `42`, `44`, `46`, `48`, `50`],
  [`Полуобхват в груди, см`, `42`, `44`, `46`, `48`, `50`],
  [`Длина, см`, `62`, `63`, `64`, `65`, `66`]
];
